import { render, staticRenderFns } from "./pendingAlarm.vue?vue&type=template&id=10a3bd48&scoped=true"
import script from "./pendingAlarm.vue?vue&type=script&lang=js"
export * from "./pendingAlarm.vue?vue&type=script&lang=js"
import style0 from "./pendingAlarm.vue?vue&type=style&index=0&id=10a3bd48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a3bd48",
  null
  
)

export default component.exports